import React, {Component} from 'react';
import * as Icon from 'react-feather'

class Question extends Component {
    constructor(props) {
        super(props);
        // console.log('this is pr:', this.props)
    }

    displayButton(index) {
        if (index > 0) {
            return <div className="previous-question__link"
                        onClick={this.props.previousQuestion}><Icon.ChevronsLeft size={15}/>Previous
                Question</div>;
        }
    }

    displayQuestion() {
        if (this.props.question) {
            return <div className="question-box">
                <h3 className="question-text">{this.props.question}</h3>
                <div id="checkbox" className="checkbox-container" onClick={this.props.nextQuestion}
                     question={this.props.question} category_id={this.props.core_category_id}>
                    <label className="question-label">
                        <input type="checkbox" name="Strongly agree" className="check-click" value="5"/>
                        <span className="checkmark"></span>
                        <span className="answer">Strongly agree</span>
                    </label>
                    <label className="question-label">
                        <input type="checkbox" name="Agree" value="4" className="check-click"/>
                        <span className="checkmark"></span>
                        Agree
                    </label>
                    <label className="question-label">
                        <input type="checkbox" name="One of us does" value="3" className="check-click"/>
                        <span className="checkmark"></span>
                        One of us does
                    </label>
                    <label className="question-label">
                        <input type="checkbox" name="Disagree" value="2" className="check-click"/>
                        <span className="checkmark"></span>
                        Disagree
                    </label>
                    <label className="question-label">
                        <input type="checkbox" name="Strongly disagree" value="1" className="check-click"/>
                        <span className="checkmark"></span>
                        Strongly disagree
                    </label>
                </div>
                {this.displayButton(this.props.questionIndex)}

            </div>
        } else {
            return <div>Processing Answers</div>
        }

    }

    render() {
        return (
            this.displayQuestion()
        )
    }

}

export default Question;